<!-- 性能优化：
     1.把效验的逻辑合并，可以减少循环次数。但是会提升代码维护和阅读难度
     2.可以用for循环替换部分forEach，return终止，可以减少循环次数。但是会提升代码维护和阅读难度
     3.调整forEach嵌套顺序，可以减少循环次数。但是会提升代码维护和阅读难度
-->
<template>
  <div class='addr-component-wrapper' @scroll.stop>

    <!--<div class="search-container">
      <input />
      <span class="search-btn"><i class="el-icon-search"></i>搜索</span>
    </div>-->

    <div class="cascader-container">
      <div class="addr-container">
        <!-- 省份列表 -->
        <div class="province">
          <div class="addr-title">省份</div>
          <div class="addr-list">
            <div
              class="addr-content"
              @click="handleProvince(item, index)"
              v-for="(item, index) in provinceList"
              :key="item.id"
              :ref="getProvinceItem">
              <div
                class="check-icon-common"
                :class="item.icon"
                @click="handleProvinceCheck(item,index)"></div>
              <div class="addr-label">{{ item.label }}</div>
              <i class="arrow el-icon-arrow-right"></i>
            </div>
          </div>
        </div>

        <!-- 城市列表 -->
        <div class="city">
          <div class="addr-title">城市</div>
          <div class="addr-list">
            <div
              class="addr-content"
              :class="item.icon ? 'active' : ''"
              @click="handleCity(item)"
              v-for="item in cityList"
              :key="item.id">
              <div class="check-icon-common" :class="item.icon"></div>
              <div class="addr-label">{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 已选列表 -->
      <div class="current-container">
        <div class="current">
          <div class="addr-title">已选</div>
          <div class="current-list addr-list">
            <transition-group name="list" tag="div" style="overflow: hidden">
              <div
                class="current-item"
                v-for="item in showList"
                :key="item.id">{{ item.label }}
                  <i class="el-icon-close" @click.stop="deleteCheckCity(item)"></i>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { watch } from '@vue/runtime-core'
export default {
  props: {
    data: [Array],
    ids: [String]
  },
  data () {
    return {
      provinceList: [],
      cityList: [],

      provinceCheckList: [],
      cityCheckList: [],

      showList: [],
      idsFlag: true,
      provinceItem: []
    }
  },
  created () {
    this.provinceList = this.data
    this.intProvinceIcon([])
    this.intCityIcon([])
  },
  watch: {
    data (newV) {
      if (newV.length > 0) {
        this.provinceList = newV
      }
    },
    ids () {
      if (this.idsFlag && !this.cityCheckList.length) {
        this.idsFlag = false
        this.setCheckCityList(this.ids)
      }
    },
    provinceList (newV, oldV) {
      if (oldV.length > 0) {
        return
      }
      if (newV.length > 0) {
        this.setCheckCityList(this.ids)
      }
    }
  },
  beforeUpdate () {
    this.provinceItem = []
  },
  methods: {
    getProvinceItem (ref) {
      this.provinceItem.push(ref)
    },
    handleProvince (item, index) {
      this.intProvinceActive(index)
      this.cityList = item.children
    },
    CityCheck (newV) {
      this.initCityList()
      this.$nextTick(() => {
        this.intProvinceIcon(newV)
        this.intCityIcon(newV)
      })
      this.intShowList(newV)
      this.$emit('change', this.expectCityList())
    },
    handleCity (cityItem) {
      if (!this.insCity(cityItem)) {
        this.cityCheckList.push(cityItem)
      } else {
        this.cityCheckList.forEach((item, index) => {
          if (cityItem.id === item.id) {
            this.cityCheckList.splice(index, 1)
          }
        })
      }
      this.CityCheck(this.cityCheckList)
    },

    // 初始化城市列表
    initCityList () {
      // 有初始值并且城市列表为空时，需要初始化
      if (this.ids && !this.cityList.length) {
        if (this.provinceList.some(item => { return item.id == this.ids.split(',')[0] })) {
          for (let i = 0; i < this.provinceList.length; i++) {
            if (this.provinceList[i].id == this.ids.split(',')[0]) {
              this.cityList = this.provinceList[i].children
              this.intProvinceActive(i)
              return
            }
          }
        } else {
          for (let i = 0; i < this.provinceList.length; i++) {
            if (this.provinceList[i].children.some(item => { return item.id == this.ids.split(',')[0] })) {
              for (let j = 0; j < this.provinceList[i].children.length; j++) {
                if (this.provinceList[i].children[j].id == this.ids.split(',')[0]) {
                  const pId = this.provinceList[i].children[j].pId
                  for (let k = 0; k < this.provinceList.length; k++) {
                    if (this.provinceList[k].id == pId) {
                      this.cityList = this.provinceList[k].children
                      this.intProvinceActive(k)
                      return
                    }
                  }
                }
              }
            }
          }
        }
      }
    },

    // 添加与移除 选中的省份列表
    handleProvinceCheck (province, index) {
      if (!this.provinceCheckList.length) {
        this.provinceCheckList.push(province)
        this.intCity(province)
        return
      }
      if (this.insProvince(province)) {
        this.provinceCheckList.forEach((item, i) => {
          if (item.id === province.id) {
            this.provinceCheckList.splice(i, 1)
          }
        })
      } else {
        this.provinceCheckList.push(province)
      }
      this.intCity(province)
    },

    // 添加与移除 省份时，把对应的城市 映射到 选中的城市列表中
    intCity (province) {
      const children = province.children
      if (this.insProvince(province)) { // 添加
        children.forEach(cityItem => {
          if (!this.insCity(cityItem)) {
            this.cityCheckList.push(cityItem)
          }
        })
      } else { // 移除
        children.forEach(cityItem => {
          this.cityCheckList.forEach((item, index) => {
            if (cityItem.id === item.id) {
              this.cityCheckList.splice(index, 1)
            }
          })
        })
      }
      this.CityCheck(this.cityCheckList)
    },

    // 已选列表 删除按钮
    deleteCheckCity (deleteItem) {
      let flag = true
      this.cityCheckList.forEach((cityCheckItem, index) => {
        if (cityCheckItem.id === deleteItem.id) {
          this.cityCheckList.splice(index, 1)
          flag = false
        }
      })
      if (flag) {
        this.provinceList.forEach(provinceItem => {
          if (provinceItem.id === deleteItem.id) {
            provinceItem.children.forEach((cityItem, index) => {
              this.cityCheckList = this.cityCheckList.filter(cityCheckItem => {
                return cityCheckItem.id !== cityItem.id
              })
            })
          }
        })
      }
      this.CityCheck(this.cityCheckList)
    },

    // 效验省份 焦点样式
    intProvinceActive (index) {
      this.$nextTick(() => {
        for (let i = 0; i < this.provinceItem.length; i++) {
          if (index === i) {
            this.provinceItem[i].className = 'addr-content active'
          } else {
            this.provinceItem[i].className = 'addr-content'
          }
        }
      })
    },

    // 效验 已选列表
    intShowList (cityCheckList) {
      this.showList = JSON.parse(JSON.stringify(cityCheckList))
      this.provinceList.forEach((provinceItem, index) => {
        // 是否为 省份
        let provinceFlag = true
        provinceItem.children.forEach(cityItem => {
          if (!cityCheckList.some(cityCheckItem => { return cityCheckItem.id === cityItem.id })) {
            provinceFlag = false
          }
        })
        if (!cityCheckList.length) {
          provinceFlag = false
        }
        if (provinceFlag) {
          provinceItem.children.forEach(cityItem => {
            this.showList = this.showList.filter(showItem => {
              return showItem.id !== cityItem.id
            })
          })
          this.showList.unshift(provinceItem)
        }
      })
    },

    // 效验 省份与省份icon
    intProvinceIcon (cityCheckList) {
      this.provinceCheckList = []
      this.provinceList.forEach((provinceItem, index) => {
        // 是否为 全选icon
        let iconFlag = true
        this.provinceList[index].icon = ''
        provinceItem.children.forEach(cityItem => {
          if (!cityCheckList.some(cityCheckItem => { return cityCheckItem.id === cityItem.id })) {
            iconFlag = false
          }
          if (cityCheckList.some(cityCheckItem => { return cityCheckItem.id === cityItem.id })) {
            this.provinceList[index].icon = 'el-icon-minus'
          }
        })

        if (!cityCheckList.length) {
          iconFlag = false
        }
        if (iconFlag) {
          this.provinceList[index].icon = 'el-icon-check'
          this.provinceCheckList.push(provinceItem)
        }
      })
    },

    // 效验城市icon
    intCityIcon (cityCheckList) {
      this.provinceList.forEach(provinceItem => {
        const cityList = provinceItem.children
        cityList.forEach((cityItem, cityIndex) => {
          if (cityCheckList.some(checkItem => { return cityItem.id === checkItem.id })) {
            cityList[cityIndex].icon = 'el-icon-check'
          } else {
            cityList[cityIndex].icon = ''
          }
        })
      })
    },

    // 查看是否在已选择的省份列表中
    insProvince (province) {
      return this.provinceCheckList.some((item, index) => {
        return item.id === province.id
      })
    },

    // 查看是否在已选择的城市列表中
    insCity (city) {
      return this.cityCheckList.some((item, index) => {
        return item.id === city.id
      })
    },

    /* 数据处理 */
    // 返回
    expectCityList () {
      const obj = {}
      const idArr = []
      this.showList.forEach(item => {
        idArr.push(item.id)
      })
      return { id: idArr.join(','), label: this.getArea() }
    },

    // 获取area
    getArea () {
      // obj: { pid: [lable,label]}
      const obj = {}
      // arr: ['北京:0', '广东省: 广州|韶关']
      const arr = []
      const arr2 = []
      this.showList.forEach((item, index) => {
        if (item.pId === 0) {
          arr.push(`${item.label}:0`)
        } else {
          let flag = true
          for (const key in obj) {
            if (Number(key) === item.pId) {
              flag = false
              obj[item.pId].push(item.label)
            }
          }
          if (flag) {
            obj[item.pId] = [item.label]
          }
        }
      })
      for (const key in obj) {
        this.provinceList.forEach(item => {
          if (item.id == key) {
            let str = item.label + ':'
            str += obj[key].join('|')
            arr.push(str)
          }
        })
      }
      return arr.join(',')
    },

    // 初始值
    setCheckCityList (str) {
      if (!str) {
        return
      }
      const arr = str.split(',').map(Number)
      arr.forEach(idItem => {
        this.provinceList.forEach(provinceItem => {
          if (idItem === provinceItem.id) {
            provinceItem.children.forEach(cityItem => {
              this.cityCheckList.push(cityItem)
            })
          } else {
            provinceItem.children.forEach(cityItem => {
              if (idItem === cityItem.id) {
                this.cityCheckList.push(cityItem)
              }
            })
          }
        })
      })
      this.CityCheck(this.cityCheckList)
    }

  }
}
</script>

<style lang='scss' scoped>
.addr-component-wrapper{
  width: 100%;
  font-size: 12px;
  color: #7b7d85;
  .search-container{
    display: flex;
    height: 30px;
    border: 1px solid rgba(221, 223, 237, 1);
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    >input{
      flex: 1;
      text-indent: 10px;
      height: 30px;
      border: none;
      outline: none;
    }
    >.search-btn{
      flex: 0 0 70px;
      margin: 0;
      border-left: 1px solid rgba(221, 223, 237, 1);
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
  }

  .cascader-container{
    display: flex;
    // 左侧地址选择
    .addr-container{
      flex: 2;
      display: flex;
      border: 1px solid rgba(221, 223, 237, 1);
      border-radius: 4px;
      font-size: 0;
      .province{
        flex: 1;
        width: 50%;
        border-right: 1px solid rgba(221, 223, 237, 1);
        box-sizing: border-box;
        font-size: 12px;
      }
      .city{
        flex: 1;
        width: 50%;
        font-size: 12px;
      }
      .addr-content{
        display: flex;
        align-items: center;
        height: 30px;
        padding-left: 10px;
        .check-icon-common{
          margin-right: 10px;
          width: 12px;
          height: 12px;
          border-radius: 1px;
          cursor: pointer;
          border: 1px solid #ddd;
          &.el-icon-minus,&.el-icon-check{
            color: #fff;
            border: 1px solid rgb(100, 125, 255);
            background: rgb(100, 125, 255);
          }
        }
        .addr-label{
          flex: 1;
        }
        .arrow{
          margin-right: 10px;
        }
        &.active{
          color: rgb(100, 125, 255);
        }
      }
    }
    // 右侧已选城市
    .current-container{
      flex: 1;
      margin-left: 20px;
      border: 1px solid rgba(221, 223, 237, 1);
      border-radius: 4px;
      .current-list{
        padding: 10px 0;
        box-sizing: border-box;
      }
      .current-item{
        position: relative;
        margin: 0 10px 5px;
        height: 26px;
        line-height: 26px;
        background: #edf1f5;
        border-radius: 4px;
        text-indent: 10px;
        .el-icon-close{
          position: absolute;
          top: 2px;
          right: 5px;
          padding: 5px 0;
          text-align: center;
          cursor: pointer;
        }
      }
    }

    /* 列表内相关 */
    .addr-title{
        padding-left: 10px;
        height: 30px;
        border-bottom: 1px solid rgba(221, 223, 237, 1);
        line-height: 30px;
        font-weight: bold;
      }

      .addr-list{
        max-height: 200px;
        overflow: auto;
      }
  }

  .list-enter-active, .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter, .list-leave-to
  /* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(20px);
  }
}
</style>
